import { useState, useEffect } from "react";
import LogoMark from "./LogoMark";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Services", href: "#services" },
    { label: "Why Us", href: "#why" },
    { label: "Coverage", href: "#areas" },
    { label: "FAQ", href: "#faq" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0a0a0c]/95 backdrop-blur-md border-b border-[#2a2a2c]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="#" className="flex items-center cursor-pointer">
          <LogoMark size="lg" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-[#b8b8b8] hover:text-white text-sm tracking-widest uppercase transition-colors duration-200 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Right CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:9516822003"
            className="flex items-center gap-2 text-white font-semibold text-sm cursor-pointer hover:text-[#D4AF37] transition-colors"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-[#D4AF37]"></i>
            </div>
            (951) 682-2003
          </a>
          <a
            href="#contact"
            className="bg-[#D4AF37] text-black text-sm font-bold px-5 py-2.5 rounded-sm tracking-wider uppercase hover:bg-[#c49f27] transition-colors whitespace-nowrap cursor-pointer"
          >
            Request Service
          </a>
        </div>

        {/* Mobile */}
        <div className="flex md:hidden items-center gap-3">
          <a
            href="tel:9516822003"
            className="bg-[#D4AF37] text-black px-4 py-2 rounded-sm text-sm font-bold whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill mr-1"></i>Call Now
          </a>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-white w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0a0a0c]/98 border-t border-[#2a2a2c] px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-[#b8b8b8] hover:text-white text-sm tracking-widest uppercase cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="bg-[#D4AF37] text-black text-sm font-bold px-5 py-3 rounded-sm tracking-wider uppercase text-center cursor-pointer"
          >
            Request Service
          </a>
        </div>
      )}
    </header>
  );
}
